// components/DynamicRuleEditor.jsx
import React from "react";

export default function DynamicRuleEditor({ label, rules, setRules }) {
  const addRule = () =>
    setRules([...(rules || []), { type: "between", min: 0, max: 0, qty: 0 }]);

  const update = (i, key, val) => {
    const next = [...(rules || [])];
    next[i] = { ...next[i], [key]: val };
    setRules(next);
  };

  const remove = (i) => setRules((rules || []).filter((_, idx) => idx !== i));

  return (
    <div className="fb-section">
      <div className="fb-section-head">
        <div className="fb-section-title">{label}</div>
        <button type="button" className="btn ghost" onClick={addRule}>+ Add Rule</button>
      </div>

      {(rules?.length ?? 0) === 0 && (
        <div className="fb-hint">No rules yet. Add one to override the default USD per trade.</div>
      )}

      <div className="rule-grid">
        {(rules || []).map((r, i) => (
          <div key={i} className="rule-card">
            <div className="rule-row">
              <label className="rule-label" htmlFor={`type-${i}`}>Condition</label>
              <select
                id={`type-${i}`}
                value={r.type}
                onChange={(e) => update(i, "type", e.target.value)}
              >
                <option value="between">Between</option>
                <option value="above">Above</option>
                <option value="below">Below</option>
              </select>
            </div>

            {(r.type === "between" || r.type === "above") && (
              <div className="rule-row">
                <label className="rule-label" htmlFor={`min-${i}`}>Min</label>
                <input
                  id={`min-${i}`}
                  type="number"
                  inputMode="numeric"
                  placeholder="0"
                  value={r.min ?? ""}
                  onChange={(e) => update(i, "min", Number(e.target.value))}
                />
              </div>
            )}

            {(r.type === "between" || r.type === "below") && (
              <div className="rule-row">
                <label className="rule-label" htmlFor={`max-${i}`}>Max</label>
                <input
                  id={`max-${i}`}
                  type="number"
                  inputMode="numeric"
                  placeholder="0"
                  value={r.max ?? ""}
                  onChange={(e) => update(i, "max", Number(e.target.value))}
                />
              </div>
            )}

            <div className="rule-row">
              <label className="rule-label" htmlFor={`qty-${i}`}>Qty (USD)</label>
              <input
                id={`qty-${i}`}
                type="number"
                inputMode="numeric"
                min="0"
                placeholder="e.g. 50"
                value={r.qty ?? ""}
                onChange={(e) => update(i, "qty", Number(e.target.value))}
              />
            </div>

            <div className="rule-actions">
              <button type="button" className="btn ghost small" onClick={() => remove(i)}>Remove</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
